export default function AppImage({
  image,
  name,
  containerClassName = '',
  imageClassName = '',
}) {
  const containerClass = ['App-image-box', containerClassName].filter(Boolean).join(' ');
  const imageClass = ['App-image', imageClassName].filter(Boolean).join(' ');

  return (
    <div className={containerClass}>
      <img src={image} className={imageClass} alt={name} />
    </div>
  );
}
